import { render, staticRenderFns } from "./InsideLayouts.vue?vue&type=template&id=e245b0b6&scoped=true"
import script from "./InsideLayouts.vue?vue&type=script&lang=js"
export * from "./InsideLayouts.vue?vue&type=script&lang=js"
import style0 from "./InsideLayouts.vue?vue&type=style&index=0&id=e245b0b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e245b0b6",
  null
  
)

export default component.exports